import React, { createElement, Component } from 'react';
import { Button, Group } from '@mantine/core';
import { Camera, FileDown, Mail } from 'lucide-react';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
interface ToolbeltProps {
  onScreenshot: () => void;
  onSavePDF: () => void;
  onEmail: () => void;
}
export function Toolbelt({
  onScreenshot,
  onSavePDF,
  onEmail
}: ToolbeltProps) {
  // Actual implementation of screenshot functionality
  const handleScreenshot = () => {
    const protocolCard = document.querySelector('.protocol-card');
    if (protocolCard) {
      html2canvas(protocolCard as HTMLElement).then(canvas => {
        const link = document.createElement('a');
        link.download = 'nutrivector-protocol.png';
        link.href = canvas.toDataURL('image/png');
        link.click();
      });
    } else {
      alert('Could not find protocol to screenshot');
    }
  };
  // Actual implementation of PDF functionality
  const handleSavePDF = () => {
    const protocolCard = document.querySelector('.protocol-card');
    if (protocolCard) {
      html2canvas(protocolCard as HTMLElement).then(canvas => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF({
          orientation: 'portrait',
          unit: 'mm'
        });
        // Calculate dimensions to fit the image properly in the PDF
        const imgWidth = 210; // A4 width in mm
        const imgHeight = canvas.height * imgWidth / canvas.width;
        pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
        pdf.save('nutrivector-protocol.pdf');
      });
    } else {
      alert('Could not find protocol to save as PDF');
    }
  };
  // Actual implementation of email functionality
  const handleEmail = () => {
    const protocolName = document.querySelector('.protocol-card h2')?.textContent;
    const protocolType = document.querySelector('.protocol-card h3')?.textContent;
    const subject = encodeURIComponent(`My Nutrivector Protocol: ${protocolName || 'Personalized Protocol'}`);
    const body = encodeURIComponent(`
      My Personalized Nutrivector Protocol
      ${protocolName || ''}
      ${protocolType || ''}
      View the attached PDF for my complete protocol details.
      Generated by Nutrivector
    `);
    window.location.href = `mailto:?subject=${subject}&body=${body}`;
    // Trigger PDF download after opening email
    setTimeout(() => {
      handleSavePDF();
    }, 500);
  };
  return <div className="w-full bg-slate-100 p-4 rounded-lg mt-6" data-id="element-527">
      <Group justify="center" gap="md" data-id="element-528">
        <Button onClick={handleScreenshot} leftSection={<Camera size={16} color="white" data-id="element-530" />} className="bg-blue-600 hover:bg-blue-700 text-white" data-id="element-529">
          Screenshot
        </Button>
        <Button onClick={handleSavePDF} leftSection={<FileDown size={16} color="white" data-id="element-532" />} className="bg-blue-600 hover:bg-blue-700 text-white" data-id="element-531">
          Save PDF
        </Button>
        <Button onClick={handleEmail} leftSection={<Mail size={16} color="white" data-id="element-534" />} className="bg-blue-600 hover:bg-blue-700 text-white" data-id="element-533">
          Email
        </Button>
      </Group>
    </div>;
}